import React from 'react'

const MaterialSetBackground = () => (
  <svg
    width="346"
    height="260"
    viewBox="0 0 346 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="163.5" cy="78" rx="251.5" ry="182" fill="currentColor" fillOpacity="0.05" />
  </svg>
)

export default MaterialSetBackground
